import { useJumpKind } from '../lib/jumpState'
import { useTexte } from '../texte'
import { LoadingBar } from './LoadingBar'

/**
 * The sign of a jump into the chat (1.102.0, 1.103.0, here since 1.105.0):
 * a pill with a sentence and the running bar.
 *
 * It stands in `Shell`, above every page, because a jump from the map, the
 * playlist, the photos or the polls keeps that page on screen until the
 * chat has drawn (see `lib/jumpState.ts`). In the chat it would only appear
 * once there was nothing left to wait for -- from use on the iPad: five
 * seconds of map without a sign.
 */
export function JumpSign() {
  const t = useTexte()
  const kind = useJumpKind()
  if (kind === null) return null
  // Only the way into a chat (1.110.0) says so, and appears after a breath:
  // where the chat draws at once, a sign that flashes says nothing.
  const text = kind === 'chat' ? t.chat.chatLoading : t.chat.jumpLoading
  return (
    <div className={kind === 'chat' ? 'jump-sign jump-sign--chat' : 'jump-sign'}>
      <div className="jump-loading" role="status" data-jump-loading={kind}>
        {text}
        <LoadingBar label={text} />
      </div>
    </div>
  )
}
